import React, { FunctionComponent, ReactNode } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { LinkTargetOptions, Scheme } from "./enums";
import { formatUrl, prettyPrintUrl } from "./utils";

export type LinkProps = {
    /** Adresa odkazu */
    url: string;
    /** Text odkazu */
    text?: string;
    /** Text nápovědy */
    title?: string;
    /** Komponenta, která má sloužit jako odkaz */
    children?: ReactNode;
    /** Způsob jakým se má odkaz otevřít */
    target?: LinkTargetOptions;
    /** Pokud je nastaveno a url neobsahuje schéma, přidá automaticky zvolené schéma */
    defaultScheme?: Scheme | string;
};

const classNames = bemClassNames("link");

export const Link: FunctionComponent<LinkProps> = ({
    url,
    text,
    title,
    children,
    target = LinkTargetOptions.blank,
    defaultScheme = Scheme.https,
}) => {
    return (
        <a href={formatUrl(url, defaultScheme)} title={title || text} target={target} onClick={(e) => e.stopPropagation()} className={classNames({ underline: !children })}>
            {children || text || prettyPrintUrl(url)}
        </a>
    );
};
